import React from 'react'
import { useOnlineActiveSalesQuery, CardType } from '@edge/spark/io-dashboards'
import { SingleNumberWidget } from '../../BaseComponents/SingleNumberWidget'
import type { BasicWidgetProps } from '../../types'

const PipelineVehicleListings = ({
    config: { text = 'Vehicle', text2 = 'Listings', secondaryText = 'In the last 7 days' },
    widgetId,
    handleConfig,
    readonly,
}: BasicWidgetProps): React.ReactElement => {
    const { data, loading } = useOnlineActiveSalesQuery()

    const num = data?.auction?.marketplace?.statistics?.activeListings
    const activeListings = typeof num === 'number' ? num : 'error'

    return (
        <SingleNumberWidget
            cardType={CardType.PIPELINE}
            // actionText="View Vehicles"
            // actionLink="/weneedthislink"
            number={activeListings}
            loading={loading}
            secondaryText={secondaryText}
            text={text}
            text2={text2}
            widgetId={widgetId}
            handleConfig={handleConfig}
            readonly={readonly}
        />
    )
}

export default PipelineVehicleListings
